<template>
  <v-dialog
    v-model="isDialogVisible"
    persistent
    width="500"
  >
    <v-card>
      <v-card-title class="headline">
        Agregar Pago/Reembolso
      </v-card-title>
      <v-card-text v-if="booking">
        <booking-data
          :booking="booking"
          :to-pay="toPay"
        />
      </v-card-text>
      <v-card-text>
        <v-form
          ref="form"
          @submit.prevent="onSubmit"
        >
          <!-- #### IsPayment ############## -->
          <v-switch
            v-model="itemData.isPayment"
            inset
            :label="`${itemData.isPayment ? 'Pago' : 'Reembolso'}`"
          />
          <!-- #### Amount ############## -->
          <v-text-field
            v-model="itemData.amount"
            outlined
            dense
            :rules="[validators.required, validators.decimal, validators.canPay]"
            label="Importe"
            placeholder="Importe"
            hide-details="auto"
            class="mb-6"
            no-controls
          />
          <payment-type-select
            v-model="itemData.paymentType"
          />
          <v-text-field
            v-model="itemData.paymentReference"
            outlined
            dense
            :rules="[validators.required]"
            :counter="100"
            label="Referencia"
            placeholder="Referencia"
            hide-details="auto"
            class="mb-6"
          />

          <date-picker
            ref="datePicker"
            :default="today"
            :max="today"
            @selectedDate="selectedDate"
          />
          <notes-textarea
            ref="notesTextarea"
            source="payments"
          />
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          :color="itemData.isPayment ? 'primary' : 'info'"
          class="me-3"
          type="submit"
          @click="OnSubmit()"
        >
          {{ itemData.isPayment ? 'Pagar' : 'Reembolsar' }}
        </v-btn>
        <v-btn
          color="secondary"
          outlined
          type="reset"
          @click="isDialogVisible = false"
        >
          Cancelar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { mdiClose, mdiEyeOutline, mdiEyeOffOutline } from '@mdi/js'
import { computed, ref } from '@vue/composition-api'
import { required, decimal } from '@core/utils/validation'
import currency from '@/scripts/filters/currency-filter'
import store from '@/store'
import DatePicker from '@/components/datepicker/DatePicker.vue'
import BookingData from '@/components/BookingData.vue'
import NotesTextarea from '@/components/controls/NotesTextarea.vue'
import Calculations from '@/scripts/helpers/calculations'
import PaymentTypeSelect from '@/components/selects/PaymentTypeSelect.vue'

export default {
  components: {
    DatePicker, BookingData, NotesTextarea, PaymentTypeSelect,
  },
  setup(_, { emit }) {
    const isDialogVisible = ref(false)
    const today = new Date().toISOString().split('T')[0]
    const datePicker = ref()
    const blankItemData = {
      bookingKey: '',
      date: today,
      amount: 0,
      isPayment: true,
      paymentType: 1,
      paymentReference: '',
    }
    const form = ref()
    const itemData = ref(JSON.parse(JSON.stringify(blankItemData)))
    const booking = ref()

    /** Notas */
    const notesTextarea = ref()

    /** Limpia todos los elementos del formulario, pero coloca
     * los "por default" a su valor inicial. */
    const ClearForm = () => {
      // Validamos que exista el elemento en el DOM
      // (Aplica para la primera vez que se muestra el diálogo)
      if (datePicker.value != null) {
        datePicker.value.Reset()
        form.value.resetValidation()
        notesTextarea.value.Clear()
      }
      itemData.value = JSON.parse(JSON.stringify(blankItemData))
    }

    const ShowDialog = item => {
      ClearForm()
      itemData.value.bookingKey = item.bookingKey
      booking.value = item
      isDialogVisible.value = true
    }

    const OnSubmit = () => {
      if (form.value.validate()) {
        store.dispatch('payments/apiCall', { mode: 'Insert', request: itemData.value }).then(result => {
          if (result.success) {
            // Guardamos las notas
            notesTextarea.value.Save({ sourceKey: result.data.paymentKey })

            emit('onInsert')
            isDialogVisible.value = false
          }
        })
      }
    }

    const { TotalPaid, ToPay } = Calculations()
    const toPay = computed(() => ToPay(booking.value))

    const canPay = value => {
      if (itemData.value.isPayment && value > toPay.value) {
        return `No se puede pagar mas de ${currency(toPay.value)}`
      }
      if (!itemData.value.isPayment && value > TotalPaid(booking.value)) {
        return `No se puede reembolsar más de ${currency(TotalPaid(booking.value))}`
      }

      return true
    }

    const selectedDate = date => {
      itemData.value.date = date
    }

    return {
      isDialogVisible,
      form,
      itemData,
      booking,
      today,
      datePicker,
      toPay,
      OnSubmit,
      ShowDialog,
      selectedDate,

      // Notas
      notesTextarea,

      // Validación
      validators: { required, decimal, canPay },

      // Iconos
      icons: {
        mdiClose,
        mdiEyeOutline,
        mdiEyeOffOutline,
      },
    }
  },
}
</script>
